import { roles } from "shared/constants/Constants";

const crmRoutes = {
  dashboard: [
    {
      path: "lead-list",
      lazyComponent: () =>
        import(
          /* webpackChunkName: "lead-list" */
          "feature/crm/dashboard/LeadList"
        ),
      authorized: [roles.ADMIN],
      sidebarGroup: "driverList",
      sidebarLabel: "Lead List",
    },
    {
      path: "today-lead-list",
      lazyComponent: () =>
        import(
          /* webpackChunkName: "today-lead-list" */
          "feature/crm/dashboard/TodayLead"
        ),
      authorized: [roles.ADMIN],
      sidebarGroup: "driverList",
      sidebarLabel: "Today",
    },
    {
      path: "lead-history",
      lazyComponent: () =>
        import(
          /* webpackChunkName: "lead-history" */
          "feature/crm/dashboard/LeadHistory.js"
        ),
      authorized: [roles.ADMIN, roles.TELECALLING],
      sidebarGroup: "driverList",
      sidebarLabel: "Lead History",
    },
  ],
  standalone: [
    {
      path: "details-page/lead/:leadId",
      lazyComponent: () =>
        import(
          /* webpackChunkName: "lead-detail-screen" */
          "./lead-detail-screen/LeadDetailScreen"
        ),
      protected: false,
      authorized: false,
    },
  ],
};

export default crmRoutes;
